import styled from "styled-components"

import { BaseContainer } from "../container"
import bgUrl from "../../images/templates-bg.svg"
import { devices } from "../../utils/styleVariables"

const TemplateContainer = styled(BaseContainer)``

const ImageContainer = styled.div`
  background: url(${bgUrl}) center 40% / contain no-repeat;
  & .gatsby-image-wrapper {
    margin-top: 78px;
    margin-bottom: 78px;
  }
  @media ${devices.laptop} {
    margin-top: 56px;
    background-position: top center;
  }
`

export { TemplateContainer, ImageContainer }
